export default __webpack_public_path__ + "static/media/wbtc.daf9bbf2.svg";